import { lazy, type ComponentType } from "react";
import { ROUTE_DEFINITIONS } from "./site-config";

export type RouteComponentOverrides = Partial<Record<string, ComponentType<any>>> & {
  __notFound?: ComponentType<any>;
};

const clientRouteComponents = new Map<string, ComponentType<any>>(
  ROUTE_DEFINITIONS.map((route) => [
    route.path,
    lazy(route.loader),
  ]),
);

const defaultNotFoundComponent = lazy(() => import("@/pages/not-found"));

export function getClientRouteComponent(path: string, overrides?: RouteComponentOverrides) {
  return overrides?.[path] || clientRouteComponents.get(path) || defaultNotFoundComponent;
}

export function getNotFoundComponent(overrides?: RouteComponentOverrides) {
  return overrides?.__notFound || defaultNotFoundComponent;
}
